<template>
  <span
    class="ai-visibility-status-dot"
    :class="`ai-visibility-status-dot--${normalizedStatus}`"
    :style="dotStyle"
    aria-hidden="true"
  ></span>
</template>

<script>
const SUPPORTED_STATUSES = ['great', 'improve', 'attention', 'new', 'live', 'inactive', 'active']

export default {
  name: 'StatusDot',
  props: {
    status: {
      type: String,
      default: 'great',
    },
    size: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    normalizedStatus () {
      return SUPPORTED_STATUSES.indexOf(this.status) > -1 ? this.status : 'great'
    },
    dotStyle () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        flexBasis: `${this.size}px`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-status-dot {
  display: inline-block;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--v-green7Color-base);
}

.ai-visibility-status-dot--great,
.ai-visibility-status-dot--active {
  background: var(--v-green7Color-base);
}

.ai-visibility-status-dot--improve,
.ai-visibility-status-dot--live {
  background: var(--v-profileAnchorColor-base);
}

.ai-visibility-status-dot--attention {
  background: var(--v-red11Color-base);
}

.ai-visibility-status-dot--new {
  background: var(--v-link3Color-base);
}

.ai-visibility-status-dot--inactive {
  background: var(--v-gray36Color-base);
}
</style>
